import SHA from './lib/sha';
import MD5 from './lib/md5';
import sha1Wasm from './lib/sha1-wasm';

const getEncryptor = function(type) {
  if (type === 'sha-wasm') {
    return shaWasm();
  } else if (type === 'md5') {
    return md5();
  } else {
    return sha();
  }
};

const sha = () => {
  var enc = new SHA('SHA-1', 'ARRAYBUFFER');

  return {
    readType: 'arrayBuffer',
    append: (function(encryptor) {
      return function(data) {
        return encryptor.update(data);
      };
    })(enc),
    end: (function(encryptor) {
      return function() {
        return encryptor.getHash('HEX');
      };
    })(enc),
  };
};

const shaWasm = () => {
  let isWaiting = true;
  let loadFail = false;

  // wasm
  let waitingList = [];
  let sha1Init;
  let shaFinal;
  let shaUpdate;
  let sha1Address;

  // normal
  var enc;

  sha1Wasm
    .init()
    .done(sha1WasmMod => {
      isWaiting = false;
      sha1Init = sha1WasmMod.cwrap('sha1_init', 'number');
      shaFinal = sha1WasmMod.cwrap('sha1_final', 'string', ['number']);
      shaUpdate = sha1WasmMod.cwrap('sha1_update', '', ['number', 'array', 'number']);
      sha1Address = sha1Init();
    })
    .fail(() => {
      // 失败改为普通 hash
      isWaiting = false;
      loadFail = true;
      enc = new SHA('SHA-1', 'ARRAYBUFFER');
    });

  return {
    readType: 'int8Array',
    append(data) {
      if (isWaiting) {
        waitingList.push(data);
        return '';
      }

      waitingList.forEach(item => {
        if (loadFail) {
          return enc.update(item.buffer);
        } else {
          return shaUpdate(sha1Address, item, item.length);
        }
      });
      waitingList = [];

      if (loadFail) {
        return enc.update(data.buffer);
      } else {
        return shaUpdate(sha1Address, data, data.length);
      }
    },
    end() {
      // 读完文件了还在 waiting 就不用 wasm 了
      if (isWaiting) {
        isWaiting = false;
        loadFail = true;
        enc = new SHA('SHA-1', 'ARRAYBUFFER');
        waitingList.forEach(item => {
          if (loadFail) {
            enc.update(item.buffer);
          } else {
            shaUpdate(sha1Address, item, item.length);
          }
        });
        waitingList = [];
      }

      if (loadFail) {
        return enc.getHash('HEX');
      } else {
        return shaFinal(sha1Address);
      }
    },
  };
};

const md5 = () => {
  var enc = new MD5.ArrayBuffer();

  return {
    readType: 'arrayBuffer',
    append: (function(encryptor) {
      return function(data) {
        return encryptor.append(data);
      };
    })(enc),
    end: (function(encryptor) {
      return function() {
        return encryptor.end();
      };
    })(enc),
  };
};

export default {
  getEncryptor,
};
